export {default} from './TwoPartsInfoBoxesSection'
